import React, { Component } from 'react';
import { Menu, MenuItem, IconButton } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import MenuIcon from '@material-ui/icons/Menu';
import text from '../../texts/translations';
import permissions from '../../permissions';
import Translation from '../Translation/Translation';

@inject('customerCaseStore')
@observer
class SimpleMenu extends Component {
  items = [
    {
      to: "cases",
      text: "nav.cases",
      role: permissions.levels.user
    },

    {
      onClick: () => this.newCase(),
      text: "nav.addNewCase",
      role: permissions.levels.manager
    },

    {
      to: "templates",
      text: "nav.templates",
      role: permissions.levels.admin
    },

    {
      to: "users",
      text: "nav.users",
      role: permissions.levels.admin
    },

    {
      onClick: this.logout.bind(this),
      text: "nav.logout",
      role: permissions.levels.user
    },
  ]
  state = {
    anchorEl: null
  };

  historyPush(name, id) {
    if (id) {
      this.props.history.push('/case/create/' + id);
    } else {
      this.props.history.push(name);
    }
    this.setState({ anchorEl: null });
  }

  newCase() {
    this.props.customerCaseStore.createNewCustomerCase(response => {
      this.historyPush('/case/create/' + response._id);
    });
  }

  logout() {
    this.props.customerCaseStore.logout();
    this.historyPush('/');
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <div>
        <IconButton
          color="inherit"
          aria-label="Menu"
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {
            this.items.map((item) => {
              if (!permissions.is(item.role, this.props.customerCaseStore.currentUser.templateRightsLevel)) {
                return null;
              }

              let onClick = item.onClick || (() => this.historyPush(`/${item.to}`));
              return (
                <MenuItem onClick={onClick}>
                  <Translation>{item.text}</Translation>
                </MenuItem>
              )
            })
          }
        </Menu>
      </div>
    );
  }
}

export default withRouter(SimpleMenu);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx